import { HeatBlock, Toaster } from '@learningblocks/storybook-components';
import React, { Component } from 'react';

export class Graphics extends Component {
  
  constructor(props) {
    super(props)
  
    this.state = {
      toastList: [],
      toastId: 0,

    }
  }

  setToastList = () => {

  }

  addToast = ({message, type, ...rest}) => {
    // setToastList([{...rest, message, type, id: toastId}]);
    this.setState({
      toastId: this.state.toastId + 1
    });
  };

  removeToast = (toastId) => {
    // setToastList((allTs) => allTs.filter((t) => t.id !== toastId));
  };

  countHeatBlockSolutions = () => {
    let count = 0;

    for (var i = 0; i < this.props.solutions.length; i++) {
      if (this.props.solutions[i].id !== null) {
        count++;
      }
    }
    return count;
  }

  render() {
    return (
      <>
        <Toaster.Component
          addToast={this.addToast.bind(this)}
          removeToast={this.removeToast.bind(this)}
          toastList={this.state.toastList}
          autoClose={4000}>
          <HeatBlock
            isModalOpen={this.props.isModalOpen}
            tooltip={this.props.tooltip}
            filledSlots={this.props.filledSlots}
            temperature={this.props.temperature}
            currentTemp={this.props.currentTemp}
            isHeating={this.props.isHeating}
            slots={this.props.slots}
            balance={this.props.balance}
            tubeTooltip={this.props.tubeTooltip}

            toggleModal={ (data) => this.props.toggleModalHB({ data, id: this.props.id })}
            setTemperature={ (data) => this.props.setTemperatureHB({ data, id: this.props.id })}
            checkBalance={ (data) => this.props.checkBalanceHB({ data, id: this.props.id })}
            onTubeDrop={ (data) => this.props.onTubeDropHB({ data, id: this.props.id })}
            temperatureBalance={ (data) => this.props.temperatureBalanceHB({ data, id: this.props.id })}
            removeTubeFromHeatblock={() => {
              this.props.slots.forEach((slot) => {
                if (slot.tube) {
                  this.props.setSolutionInScene({
                    id: slot.solutionId,
                    inScene: true,
                  });
                  console.log('slot: ' , slot );
                  if (slot.defaultProps && slot.defaultProps.originTubePosition && slot.defaultProps.originTubePosition.onIce) {
                    this.props.setSolutionOnIce({
                      id: slot.solutionId,
                      onIce: slot.defaultProps.originTubePosition.onIce,
                    });
    
                    this.props.setSolutionInScene({
                      id: slot.solutionId,
                      inScene: false,
                    });
    
                    this.props.addTubeToIceBucket({
                      id: slot.defaultProps.originTubePosition.onIce,
                      solutionId: slot.solutionId,
                      type: slot.defaultProps.type,
                    });
    
                    this.props.setSolutionOnRack({
                      id: slot.solutionId,
                      onRack: false,
                    })
                  }
                }

              });
    
              this.props.removeTubeFromHeatblockHB({
                id: this.props.id,
              });
            }}

            tooltipRemove={ (data) => this.props.tooltipRemoveHB({ data, id: this.props.id })}
            tooltipDisplay={ (data) => this.props.tooltipDisplayHB({ data, id: this.props.id })}
            tubeTooltipRemove={ (data) => this.props.tubeTooltipRemoveHB({ data, id: this.props.id })}
            tubeTooltipDisplay={ (data) => this.props.tubeTooltipDisplayHB({ data, id: this.props.id })}
          />
        </Toaster.Component>





{/* 
        <div aria-label={"Heat block. Select to display its available settings"} className="graphics">
          <img
            className={"HeatBlock"}
            tabIndex={0}
            style={{ pointerEvents: "none" }}
            src={(this.countHeatBlockSolutions() < 1) ? images.HeatBlock : images['HeatBlock' + this.countHeatBlockSolutions()]}
            aria-label="Power Supply." />
        </div> */}
      </>
    );
  }
}
